module.exports = __webpack_public_path__ + "static/FBA-55c0c3ad94eddf7b33cdadb54ee37b2e.png";